import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';

// Blueprint's Badge has no semantic colors, so emphasis carries the meaning:
// failures get the loudest treatment (primary + accent) so a broker notices an
// invite never arrived without opening anything, engagement is plain primary,
// and the in-flight states are muted.
const FAILURE = { appearance: 'accent', variant: 'primary' };
const ENGAGED = { appearance: null, variant: 'primary' };
const PENDING = { appearance: 'muted', variant: 'secondary' };

const STATUSES = {
  sent: { label: 'Sent', ...PENDING },
  delivered: { label: 'Delivered', ...PENDING },
  opened: { label: 'Opened', ...ENGAGED },
  clicked: { label: 'Clicked', ...ENGAGED },
  bounced: { label: 'Bounced', ...FAILURE },
  blocked: { label: 'Blocked', ...FAILURE },
  suppressed: { label: 'Suppressed', ...FAILURE },
  spam_reported: { label: 'Spam report', ...FAILURE },
  not_sent: { label: 'Not sent', ...FAILURE }
};

export default function InviteStatusPill({ status }) {
  const config = STATUSES[status];
  if (!config) return null;

  return <Badge appearance={config.appearance} variant={config.variant}>{config.label}</Badge>;
}

InviteStatusPill.propTypes = {
  status: PropTypes.string
};

InviteStatusPill.defaultProps = {
  status: null
};
